import { Group } from "@mantine/core";

interface FilterChipsGroupProps {
  children: React.ReactNode;
  "data-testid"?: string;
}

/**
 * Consistent wrapper component for filter chip groups.
 * Ensures uniform spacing and layout across all filter chip sections.
 */
const FilterChipsGroup = ({
  children,
  "data-testid": dataTestId,
}: FilterChipsGroupProps) => {
  return (
    <Group
      gap="xs"
      data-testid={dataTestId}
      mt={0}
      pt={0}
      pb={0}
      px={0}
      align="flex-start"
      style={{
        minHeight: 0,
        lineHeight: 0,
      }}
    >
      {children}
    </Group>
  );
};

export default FilterChipsGroup;
